export abstract class UUIDModel<T extends UUIDModel = any> {
  public constructor(data?: Partial<T>) {
    Object.assign(this, data);
  }
}
